var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-menu",on:{"click":_vm.clickEvent}},[_c('image-base',{attrs:{"src":require("@/assets/img/menu_icon.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }